var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.79762 0.0248804C6.15197 0.115238 6.39994 0.434377 6.39994 0.800068V5.60002H10.3999C10.6822 5.60002 10.9437 5.74886 11.0878 5.99165C11.2319 6.23444 11.2374 6.53522 11.1022 6.78309L6.30226 15.583C6.12715 15.904 5.75663 16.0655 5.40228 15.9751C5.04793 15.8848 4.79995 15.5656 4.79995 15.1999V10.4H0.799993C0.517646 10.4 0.256208 10.2511 0.11208 10.0084C-0.032048 9.76556 -0.0375196 9.46478 0.0976828 9.21691L4.89764 0.41699C5.07275 0.095951 5.44326 -0.0654773 5.79762 0.0248804ZM2.14761 8.79999H5.59995C6.04177 8.79999 6.39994 9.15816 6.39994 9.59999V12.0626L9.05228 7.20001H5.59995C5.15812 7.20001 4.79995 6.84184 4.79995 6.40002V3.93737L2.14761 8.79999Z",
    fill: "#191404"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZap);
export default __webpack_public_path__ + "static/media/zap.d29057cb.svg";
export { ForwardRef as ReactComponent };